import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {Research} from './entity/research';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {ResearchService} from './research.service';
import {catchError, finalize, map} from 'rxjs/operators';
import {ResearchListItem} from './entity/research-list-item';
import {ListResearchesResponse} from './entity/list-researches-response';

export class ResearchDataSource implements DataSource<Research> {

  private researchSubject = new BehaviorSubject<Research[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private researchService: ResearchService) {}

  connect(collectionViewer: CollectionViewer): Observable<Research[] | ReadonlyArray<Research>> {
    return this.researchSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.researchSubject.complete();
    this.loadingSubject.complete();
  }

  next(researchListItems: Research[]) {
    this.researchSubject.next(researchListItems);
  }

  // loadResearches(pageIndex = 0, pageSize = 10, filter = '', sortDirection = 'asc') {
  //
  //   this.loadingSubject.next(true);
  //
  //   this.researchService.listResearches(pageIndex, pageSize, filter, sortDirection)
  //     .pipe(
  //       // catchError(() => of(ListResearchesResponse[])),
  //       finalize(() => this.loadingSubject.next(false)),
  //       // map(response => response.researchListItems)
  //     )
  //     .subscribe(response => this.researchSubject.next(response.researchListItems));
  // }
}
